<div class="keen-slider" #sliderRef [sliderOptions]="sliderOptions" cdkSlider>
    @for (car of cars(); track car) {
        <div class="keen-slider__slide !overflow-visible" [class.is-active]="currentSlide() === $index" cdkSlide>
            <ui-m060-c010-vehicle-showroom-item
                [car]="car"
                [isFirstView]="isFirstView() && $index <= 3"
                [lastSlide]="currentSlide() === cars().length - 1"
            />
        </div>
    }

    <div class="pointer-events-none absolute inset-0 flex items-center">
        <div class="mx-auto flex w-full max-w-[1000px] justify-between px-[15px]">
            <button
                class="pointer-events-auto"
                (click)="sliderRef.slider()?.prev()"
                type="button"
                aria-label="Vorheriges Fahrzeug anzeigen"
            >
                <i
                    class="icon-slider-arrow text-grey-400 hidden size-[40px] rotate-180 text-[40px] md:flex"
                    aria-hidden="true"
                ></i>
            </button>

            <button
                class="pointer-events-auto"
                (click)="sliderRef.slider()?.next()"
                type="button"
                aria-label="Nächstes Fahrzeug anzeigen"
            >
                <i
                    class="icon-slider-arrow text-grey-400 hidden size-[40px] text-[40px] md:flex"
                    aria-hidden="true"
                ></i>
            </button>
        </div>
    </div>
</div>

<div
    class="z-[1] -mt-[8px] flex items-center justify-center gap-12"
    role="navigation"
    aria-label="Seitennavigation des Fahrzeug-Sliders"
>
    @for (item of cars(); track item.label) {
        <button
            class="size-16 rounded-full border-1 transition-all duration-200 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white/70"
            [ngClass]="$index === currentSlide() ? 'border-blue bg-blue' : 'border-grey-400 bg-white'"
            [attr.aria-label]="`Folie ${$index + 1} von ${cars().length} anzeigen`"
            [attr.aria-current]="$index === currentSlide() ? 'page' : null"
            (click)="sliderRef.goToIndex($index)"
            type="button"
        ></button>
    }
</div>
